<template>
    <section class="mx-4 pt-3">
        <tabs :tabs="rutas" class="border-bottom" />
        <div class="custom-scroll overflow-auto" style="height:calc(100vh - 121px)">
            <router-view />
        </div>
    </section>
</template>

<script>
export default {
    data(){
        return {
            rutas: [
                { titulo: 'Pedidos en proceso', ruta: 'admin.rutas-entrega-2.pedidos-proceso' },
                { titulo: 'Entregas fallidos', ruta: 'admin.rutas-entrega-2.envios-fallidos' },
                { titulo: 'Pendientes cambio estado', ruta: 'admin.rutas-entrega-2.pendiente-cambio-estado' },
                { titulo: 'Historial de pedidos', ruta: 'admin.rutas-entrega-2.historial-pedidos' },
                { titulo: 'Drivers', ruta: 'admin.rutas-entrega-2.drivers' }
            ]
        }
    }
}
</script>
